export default __webpack_public_path__ + "static/media/lawyer-1.c04a4679.png";